export const bot = {
  modal: {
    // The inbox is no longer WhatsApp-only: it merges WhatsApp, web concierge and OTA.
    title: "Boîte de réception des messages",
    subtitle: "WhatsApp, conciergerie web et OTA au même endroit",
  },

  channels: {
    all: "Tous",
    whatsapp: "WhatsApp",
    web: "Web",
    ota: "OTA",
  },

  empty: {
    title: "Aucun nouveau message",
    description: "Les nouveaux messages du bot apparaîtront ici à leur arrivée",
  },

  buttons: {
    markAll: "Tout marquer comme lu",
    goToChat: "Configurer l'agent IA",
    archive: "Archiver la conversation",
  },

  actions: {
    replyWhatsApp: "Répondre sur WhatsApp",
  },

  time: {
    now: "Maintenant",
    minuteSuffix: "min",
    hourSuffix: "h",
    daySuffix: "j",
    today: "Aujourd'hui",
    yesterday: "Hier",
  },

  questions: {
    searchPlaceholder: "Rechercher des questions...",
    answered: "Répondue",
    noAnswer: "En attente",
    withImage: "Avec image",
    empty: "Aucune question trouvée",
    confirmDelete: "Voulez-vous vraiment supprimer cette question ?",
  },

  answer: {
    assistantResponse: "Réponse de l'assistant",
    attachedImageOptional: "Image jointe (optionnelle)",
    uploadImage: "Téléverser une image",
    clickToSelect: "Cliquez pour sélectionner une image",
    changeImage: "Changer l'image",
    imagePreviewAlt: "Aperçu de l'image",
    defaultImageName: "image.jpg",
  },

  phone: {
    online: "en ligne",
    today: "Aujourd'hui",
    exampleQuestion: "Exemple de question",
    writeAnswerPlaceholder: "Rédigez une réponse à cette question...",
    writeMessagePlaceholder: "Saisissez un message...",
    answerImageAlt: "Image de la réponse",
    confirmDeleteImage: "Supprimer l'image ?",
    imageDeletedSuccess: "Image supprimée avec succès.",
    virtualAssistant: "Assistant virtuel",
  },

  search: {
    placeholder: "Rechercher par nom, téléphone ou code de réservation...",
    noResultsTitle: "Aucune conversation trouvée",
    noResultsDescription:
      "Essayez un autre nom, numéro de téléphone ou code de réservation.",
  },

  archive: {
    title: "Archiver la conversation",
    message:
      "Si vous archivez cette conversation, elle disparaîtra de cette liste. Vous pourrez toujours y accéder depuis la réservation liée.",
    cancel: "Annuler",
    confirm: "Archiver",
  },
};

export default bot;